/**
 * Get Object from entries like array
 * @param entries
 */
export function fromEntries<V = any, K = string>(entries: Iterable<[K, V]> | [K, V][] = []): { [key: string]: V } {
    if (typeof Object['fromEntries'] === 'function') {
        return Object['fromEntries'](entries as any);
    }

    return Array.from(entries).reduce(
        (obj, [key, value]) => ({
            ...obj,
            [key as any]: value,
        }),
        {},
    );
}
